module.exports = __webpack_public_path__ + "img/TV_android-series_X660G.7166c86d.png";